import React from 'react';
import { useSelector } from 'react-redux';
import FormSelect from 'shared/forms/FormSelect';
import { getHoldTypes } from 'src/slices/holdTypes';

const HoldTypeDropdown = (props) => {
    const holdTypes = useSelector(getHoldTypes);

    return (
        <FormSelect
            data={holdTypes}
            textField="description"
            dataItemKey="value"
            clearButton={false}
            {...props}
        />
    );
};

export default HoldTypeDropdown;